<template>
<div><component v-if="sportComponent" :is="sportComponent" /></div>
</template>

<script>
  import { shallowRef } from 'vue';
  import InplayMain from "@/components/Sport/Inplay/InplayMain";


  export default {
    name: "InplayView",
      components: {
        InplayMain
      },
      data:()=>{
      return{
        sport: {},
        sportComponent: shallowRef(InplayMain)
      }
    },

    mounted() {
      this.sportComponent = shallowRef(InplayMain)
    },
  }
</script>

<style scoped>
</style>